import { IBrowser, ICPU, IDevice, IEngine, IOS, UAParser } from 'ua-parser-js'

export interface IGeoLocationInformation {
  country_code?: string
  country_name?: string
  city?: string
  postal?: string
  latitude?: 53.3331
  longitude?: -6.2489
  IPv4?: string
  state?: string
  message?: string
}

export interface IDeviceInformation {
  ua: string
  browser: IBrowser
  cpu: ICPU
  device: IDevice
  engine: IEngine
  os: IOS
  geoLocationInfo: IGeoLocationInformation
}

export async function getDeviceInformation() {
  const parser = new UAParser(window.navigator.userAgent)
  try {
    const deviceInformationJsonObject: IDeviceInformation = Object.assign(
      { geoLocationInfo: await fetchDeviceInformation() },
      parser.getResult(),
    )

    return JSON.stringify(deviceInformationJsonObject)
  } catch (error) {
    return `{"message": "${error}"}`
  }
}

const fetchDeviceInformation = async () => {
  const geolocationUrl = 'https://geolocation-db.com/json/'
  try {
    const response = await fetch(geolocationUrl, {
      method: 'GET',
    })

    if (!response.ok) {
      return `{"message": "geolocation-db.com/json/ responded with status ${geolocationUrl}"}`
    }

    return response.json()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return `{"message": "${error.message}"}`
  }
}
